import React, { useEffect } from "react";
import { Drawer, Form, Input, Button } from "antd";

const CreateFoodCat = ({ open, onClose, onSubmit, initialValues }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (open) {
      form.resetFields();
    }
  }, [initialValues, open, form]);

  const handleFinish = (values) => {
    onSubmit(values);
  };

  return (
    <Drawer
      title={initialValues ? "Edit Food Category" : "Create Food Category"}
      width={420}
      open={open}
      onClose={onClose}
      destroyOnClose
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={initialValues}
        onFinish={handleFinish}
        onValuesChange={(changedValues) => {
          if (changedValues.name !== undefined) {
            form.setFieldsValue({
              code: changedValues.name
                ?.toLowerCase()
                .trim()
                .replace(/\s+/g, "_"),
            });
          }
        }}
      >
        <div className="page-card table-card">
          <div className="table-card-header">
            <div>
              <h3>{initialValues ? "Update Food Category" : "Create Food Category"}</h3>
              <p>Fill the details below to save the food category.</p>
            </div>
          </div>

          <Form.Item
            label="Food Category Name"
            name="name"
            rules={[{ required: true, message: "Please enter food category name" }]}
          >
            <Input placeholder="Enter food category name" />
          </Form.Item>

          <div className="form-actions">
            <Button className="secondary-btn" onClick={onClose}>
              Cancel
            </Button>
            <Button type="primary" htmlType="submit" className="primary-btn">
              {initialValues ? "Update Category" : "Save Category"}
            </Button>
          </div>
        </div>
      </Form>
    </Drawer>
  );
};

export default CreateFoodCat;